'use client';
import LoginPage from '@/features/auth/login/ui/LoginPage';

export default function AuthSignInPage() {
  return <LoginPage />;
}
